<template>
  <div v-loading="dataLoading">
    <rhcn-drawer
      :title="titleText"
      :description="$t('message.collection.vaFormTitleTips')"
      @on-close="handleClose">
      <template #title>
        <div class="virtual-success-top">
          <div v-if="currency" class="top-title-box">
            <img class="top-title-icon" :src="require(`@/assets/images/currency/${currency}.png`)" />
            <div>
              <p>{{$t('message.wallet.rechargeTitle', {currency: getCurrencyText()})}}</p>
              <p class="title-tips">{{$t('message.wallet.rechargeSubTitle', {currency: getCurrencyText()})}}</p>
            </div>
          </div>
        </div>
      </template>
      <div class="virtual-modal-wrapper">
        <div class="form-wrapper success-form-wrapper">
          <div class="account-info">
            <div class="account-info-box">
              <p class="account-info-name">{{$t('message.wallet.rechargeCurrencyInfo', {currency: getCurrencyText()})}}</p>
              <p class="account-info-desc">
                <i class="iconfont icon-tixing margin-right-8"></i>
                <span>{{$t('message.wallet.rechargeWaring')}}</span>
              </p>
            </div>
          </div>
          <el-form label-position="top">
            <el-form-item v-for="(item, index) in accountInfo" :key="index" :label="item.isInternationalization ? $t(item.label) : item.label">
              <div class="va-form-item">
                <span>{{item.value}}</span>
                <span class="icon-copy-box" @click="handleCopy(item.value)"><i class="iconfont icon-copy"></i></span>
              </div>
            </el-form-item>
            <el-form-item v-if="tipsList.length > 0" :label="$t('message.collection.accountFunction')">
              <div class="account-func">
                <div v-for="(item, index) in tipsList" :key="index" class="account-func-item">
                  <div class="account-func-item-title">
                    <i class="item-icon el-icon-circle-check"></i>
                    <span>{{item.functionTips}}</span>
                  </div>
                  <div class="account-func-item-desc">{{item.timeTips}}</div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div class="margin-top-40 margin-bottom-25">
          <el-button
            style="width: 100%"
            type="primary"
            @click="handleClose"
            >{{ $t("message.common.confirm") }}</el-button
          >
        </div> -->
      </div>
    </rhcn-drawer>
  </div>
</template>

<script>
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import GlobalData from '@/utils/global/index';
import { initSelectedData } from '@/utils/tools/constant';
import { getVaAccountInfoByCurrency } from '@/views/collection/api/va.js';

export default {
  components: {
    RhcnDrawer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataLoading: false,
      tipsList: [],
      accountInfo: [],
      account: {},
      statusList: [],
      titleText: this.$t('message.collection.createVirtualAccount1'),
      currency: '',
    };
  },
  created() {
    const { currency } = this.$route.query;
    this.currency = currency;
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['VA_STATUS']);
        this.statusList = initSelectedData(dict.VA_STATUS);

        const res = await getVaAccountInfoByCurrency({
          currency: this.currency,
        });
        this.accountInfo = res.infoList || [];
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    handleClose() {
      this.$router.go(-1);
    },
    async handleCopy(data) {
      await this.$copyText(data);
      ShowSuccessMessage(this.$t('message.common.copySuccess'));
    },
    getCurrencyText() {
      if (!this.currency) {
        return '';
      }
      const text = this.$t('message.currency.' + this.currency);
      if (!text || text.indexOf('message') > -1) {
        return this.currency;
      }
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.virtual-modal-wrapper {
  width: 500px;
  margin: 0 auto;
  .form-wrapper {
    width: 450px;
    margin: 23px auto 0;

    &.success-form-wrapper {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
      border-radius: 2px;
      padding: 25px;
      margin-top: 20px;

      .va-form-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: Avenir-Book, Avenir;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 32px;

        .icon-copy-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 33px;
          height: 33px;
          border-radius: 4px;
          font-size: 20px;
          font-weight: 800;
          color: $color-success;
          cursor: pointer;

          &:hover {
            background: #F1F5F7;
          }
        }
      }
    }

    .name-list {
      .name-list-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .name-input {
          width: 180px;
        }

        .el-icon-remove-outline, .el-icon-circle-plus-outline {
          font-size: 27px;
          color: $color-primary;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .fail-reason-box {
    position: relative;
    width: 450px;
    height: 30px;
    background: #FFF2F2;
    margin: 0 auto;
    margin-top: 20px;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 32px;
    padding-left: 10px;
    padding-right: 30px;
    box-sizing: border-box;
    white-space: pre-line;

    &.expand {
      height: auto;
      padding-bottom: 10px;

      .el-icon-arrow {
        transform: rotateX(180deg);
      }
    }

    .el-icon-arrow {
      position: absolute;
      right: 10px;
      top: 10px;
      transition: all 0.2s;
    }
  }
}

.account-info {
  display: flex;
  position: relative;
  color: $color-text-primary;
  border-bottom: 1px solid rgba(0,32,63,0.08);
  padding-bottom: 10px;
  margin-bottom: 20px;
  align-items: center;

  .account-info-box {
    flex: 1;
  }

  .account-info-name {
    font-size: 16px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    line-height: 32px;
  }

  .account-info-desc {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;

    .icon-tixing {
      color: $color-icon-warn;
    }
  }

  .account-info-label {
    margin-right: 20px;
  }

  .account-info-status {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}

.account-func {
  background: #F1F5F7;
  border-radius: 2px;
  padding: 10px;

  .account-func-item {
    margin-bottom: 5px;
    .account-func-item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-primary;
      line-height: 32px;

      .item-icon {
        // width: 17px;
        // height: 17px;
        font-size: 17px;
        margin-right: 10px;
        font-weight: 800;
        color: $color-success;
      }
    }

    .account-func-item-desc {
      margin-left: 27px;
      font-size: 14px;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 18px;
    }
  }
}
</style>
<style lang="scss">
@import '@/styles/variables.scss';

.virtual-success-top {
  width: 450px;
  margin: 18px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .top-title-box {
    display: flex;
    align-items: flex-start;
    font-size: 26px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: #264373;
    line-height: 36px;

    .top-title-icon {
      width: 30px;
      height: 30px;
      margin-right: 20px;
      margin-top: 5px;
    }
  }

  .title-tips {
    font-size: 16px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 22px;
  }
}

html[lang=en] .virtual-modal-wrapper .fail-reason-box {
  width: 520px !important;
}
</style>
